<template>
  <div class="zcbody" v-loading="loading" style="width: 100%;height: calc(100% - 60px)">
    <div class="contanerpric minprict"
      style="max-width: 100%;height: calc(100% - 60px);background: transparent;box-shadow:none">
      <el-card class="box-card boxcard" style="height:100%;">
        <div slot="header" class="clearfix">
          <i class="el-icon-s-unfold"></i><b>物料报表</b>
        </div>
        <tablerends ref="rendsref" @rend="rend" :dt2table1="tablelist0" :tableHead="tableHead" />
        <!-- 可以使用span 和 span-map对象来控制栅格的大小 -->
      </el-card>
    </div>
  </div>
</template>

<script>
  import tablerends from "./tabletrends.vue";
  export default {
    components: {
      tablerends,
    },
    data () {
      return {
        dt2: {
          Table: [],
          Table1: [],
        },
        urlid: "",
        KeyValue: "",
        loading: false,
        tableHead: [],
        tablelist0: [],
        tabint: 0,
        unicvename: [],
      };
    },
    created () {
      this.KeyValue = this.$route.query.KeyValue;
      // this.KeyValue = "34FEA0CF-D265-4793-A22A-8EE9EAF26845";
      if (this.KeyValue != "") {
        this.GetLogInfoByCode();
      }
    },
    methods: {
      // 监听授标完成
      rend (val) {
        this.GetLogInfoByCode();
      },
      // 获取基本信息
      GetLogInfoByCode () {
        this.$axios({
          method: "post",
          url: "CommonModule/Inventory/GetInventoryInfo",
          data: { KeyValue: this.KeyValue },
        }).then((res) => {
          console.log(res);
          this.loading = false;
          if (res.data.Success) {
            this.dt2.Table = res.data.Data.Table1;
            this.dt2.Table1 = res.data.Data.Table;
            this.arryzli();
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },

      // 返回
      returnpage () {
        sessionStorage.removeItem("params");
        this.$router.push({ path: "/pricinglist?KeyValue=" + this.KeyValue });
      },
      arryzli () {
        const res = new Map();
        this.tableHead = [];
        var tablelist1 = this.dt2.Table1.filter(
          (arr) => !res.has(arr.cvenname) && res.set(arr.cvenname, 1)
        );
        for (var a = 0; a < tablelist1.length; a++) {
          this.tableHead.push({
            label: tablelist1[a].cvenname,
            property: "cvename" + tablelist1[a].cvencode,
            child: [],
          });
        }
        // console.log(this.tableHead);
        var tablelist = this.dt2.Table1;
        var tablelist0 = this.dt2.Table;
        for (var b = 0; b < tablelist.length; b++) {
          tablelist0.forEach((tablistnew) => {
            if (tablelist[b].cinvcode == tablistnew.cinvcode) {
              this.$set(
                tablistnew,
                "cvename" + tablelist[b].cvencode,
                tablelist[b].ivensum
              );
              tablistnew = Object.assign(tablistnew, tablelist[b]);
            }
          });
        }
        this.tablelist0 = tablelist0.filter(
          (arrdt2) => !res.has(arrdt2.cinvcode) && res.set(arrdt2.cinvcode, 1)
        );
        console.log(this.tablelist0, "this.tablelist0this.tablelist0");
        const cvenres = new Map();
        var unitable = this.dt2.Table1.filter(
          (arr) => !cvenres.has(arr.cvenname) && cvenres.set(arr.cvenname, 1)
        );
        this.unicvename = [];
        for (var a = 0; a < unitable.length; a++) {
          this.unicvename.push("cvename" + this.dt2.Table1[a].cvencode);
        }
        this.tabint = 0;
        this.tabunit();
      },
      tabunit () {
        if (this.tabint == this.tablelist0.length) {
          return false;
        }
        var intnumber = Number(this.tabint);
        var temptablelist = this.tablelist0[intnumber];
        var allcvename = 0;
        for (var key in temptablelist) {
          this.unicvename.forEach((item) => {
            if (item == key) {
              allcvename += Number(temptablelist[key]);
            }
          });
        }
        this.tablelist0[intnumber].allcvename = allcvename;
        this.tabint++;
        this.tabunit();
      },
      // 去重
      unique (arr) {
        const res = new Map();
        return arr.filter(
          (arr) => !res.has(arr.cclasscode) && res.set(arr.cclasscode, 1)
        );
      },
    },
  };
</script>

<style scoped>
  @import url(../../assets/css/reg.css);
</style>